import {
  ELE_GETLISTADO_COMPLETE,
  ELE_GETELEMENTOS_COMPLETE,
} from "../../const/actionTypes";
import { get } from "lodash";

const initialState = {
  listado: [],
  elementos: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ELE_GETLISTADO_COMPLETE:
      return { ...state, listado: get(action, "payload") };
    case ELE_GETELEMENTOS_COMPLETE:
      return { ...state, elementos: get(action, "payload") };
    default:
      return { ...state };
  }
}
